module.exports = __webpack_public_path__ + "img/عمومی.e2d2907c.jpg";